(function () {
  function buildShareUrl(canonicalUrl, currentUrl) {
    const url = new URL(canonicalUrl);
    const variant = new URL(currentUrl).searchParams.get('variant');
    if (variant) url.searchParams.set('variant', variant);
    return url.href;
  }

  async function shareProduct(data, { share, copy }) {
    if (share) {
      try {
        await share(data);
        return 'shared';
      } catch (error) {
        if (error.name === 'AbortError') return 'cancelled';
      }
    }
    if (copy) {
      try {
        await copy(data.url);
        return 'copied';
      } catch {}
    }
    return 'manual';
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { buildShareUrl, shareProduct };
  }

  if (typeof customElements === 'undefined' || customElements.get('product-share')) return;

  class ProductShare extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.input = this.querySelector('input');
      if (!this.button || !this.status || !this.input) return;
      this.initialized = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.handleShare());
    }

    getShareData() {
      return {
        title: this.dataset.title,
        url: buildShareUrl(this.dataset.url, window.location.href)
      };
    }

    getShareCapabilities() {
      return {
        share: typeof navigator.share === 'function' ? navigator.share.bind(navigator) : null,
        copy: navigator.clipboard?.writeText?.bind(navigator.clipboard)
      };
    }

    showResult(result, url) {
      if (result === 'copied') this.status.textContent = this.status.dataset.success;
      if (result === 'manual') {
        this.input.value = url;
        this.input.hidden = false;
        this.input.focus();
        this.input.select();
      }
    }

    async handleShare() {
      if (this.button.disabled) return;
      this.button.disabled = true;
      this.status.textContent = '';
      this.input.hidden = true;
      try {
        const data = this.getShareData();
        const result = await shareProduct(data, this.getShareCapabilities());
        if (this.isConnected) this.showResult(result, data.url);
      } finally {
        this.button.disabled = false;
      }
    }
  }

  customElements.define('product-share', ProductShare);
})();
